import { render, staticRenderFns } from "./IndexDocument.vue?vue&type=template&id=2bbd0782&"
import script from "./IndexDocument.vue?vue&type=script&lang=js&"
export * from "./IndexDocument.vue?vue&type=script&lang=js&"
import style0 from "./IndexDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports